export enum EUIAction {
  SET_DEVICE = 'SET_DEVICE',
  RESET_ACTION_STATUS = 'RESET_ACTION_STATUS',
}
